import React, { useEffect } from 'react';
import LazyHydration from 'react-lazy-hydration';
import i18next from 'i18next';
import { initLanguage, changeLanguage } from 'i18n';

export const LanguageProvider: React.FC<Props> = ({ code, children }) => {
  const languageResolved = new Promise((resolve) =>
    i18next.on('initialized', resolve),
  );
  useEffect(() => {
    const init = async () => {
      const { lang } = window;
      await initLanguage(lang, code);
      await changeLanguage(code);
    };

    init();
  }, [code]);
  return (
    <LazyHydration promise={languageResolved}>
      <>{children}</>
    </LazyHydration>
  );
};

interface Props {
  code: string;
  children: React.ReactNode;
}
